export type ReorderEdge = 'top' | 'bottom';

/** Sort endpoint siblings by their persisted priority before applying a move. */
export function reorderRuleIds(
  rules: readonly { id: number; order: number }[],
  sourceId: number,
  targetId: number,
  edge: ReorderEdge,
): number[] {
  const ids = [...rules].sort((left, right) => left.order - right.order || left.id - right.id).map((rule) => rule.id);
  return reorderIds(ids, sourceId, targetId, edge);
}

/** Return a complete endpoint-local ordering without mutating the input. */
export function reorderIds(ids: readonly number[], sourceId: number, targetId: number, edge: ReorderEdge): number[] {
  if (sourceId === targetId) return [...ids];
  if (!ids.includes(sourceId) || !ids.includes(targetId)) return [...ids];

  const result = ids.filter((id) => id !== sourceId);
  result.splice(result.indexOf(targetId) + (edge === 'bottom' ? 1 : 0), 0, sourceId);
  return result;
}
